export default {
    SET_DATA_QURBAN(state, payload) {
        state.qurbans = payload.data;
        state.totalQurban = payload.recordsTotal;
    },
    SET_DATA_OTHER(state, data) {
        state.otherQurbans = data;
    },
    SET_TRANSACTION_PRODUCT(state, data) {
        state.transactionProduct = data;
    },
    SET_TRANSACTION_PAYMENT(state, data) {
        state.transactionPayment = data;
    },
    SET_TRANSACTION_HISTORY(state, data) {
        state.transactionHistory = data;
    },
    SET_TRACKING_CODE(state, kode) {
        state.track.kode = kode;
    },
    SET_TRACKING_DATA(state, data) {
        state.track.data = data;
    },
    REMOVE_TRANSACTION_PRODUCT(state) {
        state.transactionProduct = null;
    },
    REMOVE_TRANSACTION_PAYMENT(state) {
        state.transactionPayment = null;
    },
    REMOVE_TRANSACTION_HISTORY(state) {
        state.transactionHistory = null;
    },
    REMOVE_TRACKING_CODE(state) {
        state.track.kode = null;
    }
}